var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", {}, [
    _c("h2", { staticClass: "h3" }, [
      _vm._v("\n   " + _vm._s(_vm.$t("ic_new_gdzie_dzis_jedziemy")) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "typehead-container mb-3" },
      [
        _c(
          "vue-typeahead-bootstrap",
          {
            staticClass: "start no-border",
            attrs: {
              data: [
                "Warszawa",
                "Gdańsk",
                "Wałbrzych",
                "Wąchock",
                "Warka",
                "Wałcz",
              ],
              placeholder: "Wybierz miejscowość",
              showOnFocus: true,
            },
            scopedSlots: _vm._u([
              {
                key: "suggestion",
                fn: function ({ data, htmlText }) {
                  return [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("img", {
                        staticClass: "ms-1",
                        staticStyle: { width: "20px", height: "20px" },
                        attrs: { src: "/images/pin-blue.svg" },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "ms-2",
                        domProps: { innerHTML: _vm._s(htmlText) },
                      }),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.query1,
              callback: function ($$v) {
                _vm.query1 = $$v
              },
              expression: "query1",
            },
          },
          [
            _c("template", { slot: "append" }, [
              _vm._v(
                "\n        [[%icsearch_skad? &namespace=icsearch &topic=form]]\n      "
              ),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _vm._m(0),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "typehead-container mb-3" },
      [
        _c(
          "vue-typeahead-bootstrap",
          {
            directives: [{ name: "reset-input", rawName: "v-reset-input" }],
            staticClass: "end no-border",
            attrs: {
              data: [
                "Warszawa",
                "Gdańsk",
                "Wałbrzych",
                "Wąchock",
                "Warka",
                "Wałcz",
              ],
              placeholder: "Wybierz miejscowość",
              showOnFocus: true,
            },
            scopedSlots: _vm._u([
              {
                key: "suggestion",
                fn: function ({ data, htmlText }) {
                  return [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("img", {
                        staticClass: "ms-1",
                        staticStyle: { width: "20px", height: "20px" },
                        attrs: { src: "/images/pin-blue.svg" },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "ms-2",
                        domProps: { innerHTML: _vm._s(htmlText) },
                      }),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.query2,
              callback: function ($$v) {
                _vm.query2 = $$v
              },
              expression: "query2",
            },
          },
          [
            _c("template", { slot: "append" }, [
              _vm._v(
                "\n        [[%icsearch_dokad? &namespace=icsearch &topic=form]]\n      "
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mb-3" }, [_c("date-time")], 1),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c(
      "button",
      { staticClass: "btn btn-warning w-100 mb-2", attrs: { type: "submit" } },
      [_vm._v("Szukaj")]
    ),
    _vm._v(" "),
    _vm._m(2),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "switch d-flex h-100 align-items-center",
        attrs: { href: "#" },
      },
      [_c("i", { staticClass: "bi bi-arrow-down-up" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-3" }, [
      _c(
        "div",
        {
          staticClass: "alert alert-warning font-size-sm",
          attrs: { role: "alert" },
        },
        [
          _c("p", [
            _vm._v(
              "W pociągach PKP Intercity jednocześnie zajętych może być co najwyżej 50 proc. miejsc siedzących."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("a", { attrs: { href: "#" } }, [
              _vm._v(
                "Więcej informacji na temat obowiązujących zasad w podróży"
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c(
        "a",
        { staticClass: "btn-link btn-adv-search", attrs: { href: "#" } },
        [_vm._v("Szczegółowa wyszukiwarka połączeń")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }